<template>
  <section>
    <div class="scroll">
      <div class="cont top">
        <div class="day-col" v-for="(day,index) in getDays" v-bind:key="index" :ref="index">
          <div class="day-col-day">{{ day.day }}</div>
          <div class="day-col-day-w">{{ day.dayOfWeek }}</div>
        </div>
      </div>
      <div class="cont off" v-for="(stream, i) in streams" v-bind:key="i"> &nbsp;
        <div  class="day-col"
              :class="{ 'on':index%2 }"
              v-for="(day, key, index) in getDays"
              v-bind:key="index"
              :ref="'d'+key">

          <section v-for="(event, j) in getEvents({ day, stream })" v-bind:key="j">
            <div v-if="event.isEventStart" class="event-cont" :class="{ 'bm': !isEventOn(day, event, stream) }"  >
                <div  v-on:click="showDetails(event)"
                      class="event"
                      :class="{ pointer: ifLink(event) }"
                      :style="{ 'background-color':event.color, width:`${getColWidth(event)}px` }">
                  <span >{{ event.titleMobile || event.title }}</span>
                </div>
            </div>
            <div v-else-if="isEventOn(day, event, stream)" class="event-cont" >&nbsp;</div>
          </section>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
// TODO build ems version
// TODO offline
// TODO loading, catch, errors, finally
// TODO lstring
// TODO i18n lexon
// TODO options with - create query function param that queries and returns mapped data
// TODO options with - env vars overides
// TODO detailed readme
// TODO TESTS - src, umd, wc, wca
// TODO CI

import { DateTime } from 'luxon'
import   axios      from 'axios'

export default {
  name    : 'ConferenceCal',
  props   : [ 'code', 'options' ],
  methods : { getEvents, isEventStart, isEventOn, showDetails, setState, loadEvents, ifLink, onHover, queryConference },
  computed: { getDays, getColWidth },
  data, mounted
}

function mounted (){ this.$watch('events', () => this.$forceUpdate()) }

function data(){
  this.setState()
  return { local: 'en', days: {}, start: '', end: '', streams: [], events: [] }
}

function onHover(){ window.document.body.style.cursor = 'pointer' }

function ifLink(event){
  if(event.url) return event.url
  if(event.code) return `https://www.cbd.int/conferences/${this.code}/parallel-meetings/${event.code}`
  return false
}

function getEvents({ day, stream }){
  if(!this.events || !this.events.length) return []

  return this.events.map(event => {
    event.isEventStart = this.isEventStart(day, event, stream)
    return event
  })
}

function loadEvents(events){
  if(!events) return
  for (let i = 0; i < events.length; i++){
    events[i].end    = DateTime.fromISO(events[i].end)
    events[i].start  = DateTime.fromISO(events[i].start)
    events[i].length = (events[i].end.diff(events[i].start, 'days').toObject().days || 0)+1
  }
}

const PARAMS = {
  params: {
    f : { 'apps.conferenceCal': 1 },
    fo: 1
  }
}

async function queryConference(){
  const path     = `https://api.cbd.int/api/v2016/conferences/`
  const { code } = this

  PARAMS.params.q = { code }

  const { data } = await axios.get(path, PARAMS)

  if(!data.apps) throw new Error('No conference found')

  return data.apps
}

async function setState(){
  const { conferenceCal } = await this.queryConference()

  if(!conferenceCal) throw new Error('No app data found: apps.conferenceCal')

  const { streams, events, start, end }   = conferenceCal

  this.start   = DateTime.fromISO(start)
  this.end     = DateTime.fromISO(end)
  this.streams = streams
  this.events  = events

  this.loadEvents(this.events)
  return this.events
}

function showDetails (e){
  if(this.ifLink(e) && !e.code || (this.options && this.options.target==='_blank'))
    window.open(this.ifLink(e), '_blank')
  else window.location = this.ifLink(e)
}

function getColWidth(){
  return event => {
    if(!this.$refs['d'+event.start.toFormat('yyyyMMdd')]) return
    return this.$refs['d'+event.start.toFormat('yyyyMMdd')][0].clientWidth * event.length
  }
}

function isEventStart(day, event, stream){
  if(day.date.day===event.start.day && event.stream===stream) return true
  else return false
}

function isEventOn(day, event, stream){
  if(day.date.day>event.start.day && day.date.day<=event.end.day && event.stream===stream) return true
  else return false
}

function getDays(){
  if(!this.start) return
  const diff = this.end.diff(this.start, 'days').toObject().days

  for (let i = 0; i < diff; i++){
    const day = this.start.plus({ days: i }).startOf('day')
    const dayObj = {
      day      : day.day,
      dayOfWeek: day.setLocale(this.locale).toFormat('ccc'),
      date     : day
    }

    this.days['d'+day.toFormat('yyyyMMdd')] = dayObj
  }
  return this.days
}
</script>

<style scoped>
  .pointer  { cursor:pointer; pointer-events:all; }
  .stream   { padding: 1em 0 1em 0; }
  .bm       { margin-bottom:.7em; }
  .on       { background: #F2F1EF; }
  .cont     { display: inline-flex; width:270%; }
  .top      { margin-bottom: .25em }
  .debugB   { border: 1px solid blue; width:100%; overflow-x: scroll; }
  .scroll   { width:100%; overflow-x: auto; }
  .debug    { border: 1px solid red; }
  .off      { margin-left:-0.3em }

  .day-col-day-w{ background: #D2D7D3; text-align: center; border-right: 1px solid white; }
  .day-col      { width:100%; position: relative; }
  .day-col-day  {
    background: #95A5A6;
    color: white;
    text-align: center;
    font-weight: bold;
    border-right: 1px solid white;
  }
  .event-cont   {
    position      : relative;
    width         : 100%;
    padding       : .5em 0 1em 0;
    font-size     : 1.2em;
    z-index       : 10;
    font-weight   : bold;
    pointer-events: none;
  }
  .event   {
    position: absolute;
    color: white;
    top: 50%;
    transform: translate(0, -50%);
    font-size: .6em;
    text-align: center;
    border-left: 1px solid white;
    border-right: 1px solid white;
    max-height: 60px;
    z-index: 100;
    line-height: 1.2em;
    padding: .2em 0 .2em .1em;
  }
  @media  (min-width:768px) {
    .cont{ width:150%; }
  }

  @media (min-width:992px) {
    .cont{ width:135%; }
  }
</style>
